import React from "react";
import { SettingsWrapper, DayNightWrapper } from "./Wrapper.jsx";
import { Button, ButtonGroup } from "bootstrap-micro";

export function HeatEditor(props) {
    return <ButtonGroup>
        {["Off", "On"].map((l, i) => <Button  key={i} type="button"
            disabled={props.disabled}
            className={props.value == i ? "btn-primary" : null}
            onClick={() => props.onChange({ target: { value: i } })} >{l}</Button>
        )}
    </ButtonGroup>

}

export default SettingsWrapper(DayNightWrapper(HeatEditor, true));

